<ng-container [ngSwitch]="treatmentType">
  <app-mens-intimate-wash-bacterial-vaginosis *ngSwitchCase="ConsultationTreatmentTypes.BacterialVaginosis" />
  <app-mens-intimate-wash-ed *ngSwitchCase="ConsultationTreatmentTypes.Ed" />
  <app-mens-intimate-wash-hsv *ngSwitchCase="ConsultationTreatmentTypes.Hsv" />
  <app-mens-intimate-wash-male-bv *ngSwitchCase="ConsultationTreatmentTypes.MaleBv" />
  <app-mens-intimate-wash-metformin *ngSwitchCase="ConsultationTreatmentTypes.Metformin" />
  <app-mens-intimate-wash-uti *ngSwitchCase="ConsultationTreatmentTypes.Uti" />
  <app-mens-intimate-wash-yeast-infection *ngSwitchCase="ConsultationTreatmentTypes.YeastInfection" />
  <app-mens-intimate-wash-zofran *ngSwitchCase="ConsultationTreatmentTypes.Zofran" />
  <app-mens-intimate-wash *ngSwitchDefault />
</ng-container>
